import React from 'react';
import { useTranslation } from 'react-i18next';
import { Project60StickyBanner as Quiz4UrgencyBanner } from '../Quiz4UrgencyBanner';
import { FallSaleBanner } from './FallSaleBanner';
import { Web48Arm } from '../../web48Offer';

interface Web48BannerProps {
  arm: Web48Arm;
  endsAt?: number;
}

// web48_timer_banner: the one banner a web48 visitor sees on quiz pages and
// pricing. Same copy and end date in both arms; only the UI differs.
//   control   – today's banner, "EXCLUSIVE FALL SALE" copy, days:hrs:min:sec pill
//   variation – Oben's bar (FallSaleBanner)
// Past the end date both keep their copy and say "ends today" where the
// countdown was (Steven, Oct 30); the price never changes.
export const Web48Banner = ({ arm, endsAt }: Web48BannerProps) => {
  const { t } = useTranslation();
  if (arm === 'variation') return <FallSaleBanner endsAt={endsAt} />;

  // Ethan, Oct 30: control reads "EXCLUSIVE FALL SALE: Get 20% Off + 14 Days Free".
  const offer = t('results.banner.web48.controlOffer', { percent: 20 });
  return (
    <div data-testid="web48-control-banner">
      <Quiz4UrgencyBanner
        line1={t('results.banner.web48.saleLabel')}
        line2={offer}
        line3={`${t('results.banner.web48.saleLead')} ${offer}`}
        showTimer={endsAt !== undefined}
        showDays
        expiresAt={endsAt}
        endedText={t('results.banner.web48.endsToday')}
      />
    </div>
  );
};
